import { render, staticRenderFns } from "./GiftCardStatistics.vue?vue&type=template&id=88a6356a&"
import script from "./GiftCardStatistics.vue?vue&type=script&lang=js&"
export * from "./GiftCardStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports